import { createContext, useContext, useEffect, useMemo, useState } from 'react'
import type { ReactNode } from 'react'

type Crumbs = string[] | null

interface BreadcrumbApi {
  crumbs: Crumbs
  setCrumbs: (crumbs: Crumbs) => void
}

const BreadcrumbContext = createContext<BreadcrumbApi | null>(null)

export function BreadcrumbProvider({ children }: { children: ReactNode }) {
  const [crumbs, setCrumbs] = useState<Crumbs>(null)
  const value = useMemo(() => ({ crumbs, setCrumbs }), [crumbs])
  return <BreadcrumbContext.Provider value={value}>{children}</BreadcrumbContext.Provider>
}

export function useBreadcrumbState(): BreadcrumbApi {
  const context = useContext(BreadcrumbContext)
  if (!context) throw new Error('BreadcrumbProvider brakuje w drzewie')
  return context
}

/**
 * Nadpisuje okruszki w topbarze dla bieżącej strony:
 * `useBreadcrumb(['Sprawy', 'II C 1245/25'])`.
 * Bez wywołania okruszki liczone są z nawigacji (moduł / pozycja menu).
 */
export function useBreadcrumb(crumbs: string[]): void {
  const { setCrumbs } = useBreadcrumbState()
  const key = JSON.stringify(crumbs)
  useEffect(() => {
    setCrumbs(JSON.parse(key) as string[])
    return () => setCrumbs(null)
  }, [key, setCrumbs])
}
